/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';
import type { GoldenRecord } from './GoldenRecord';
import {
    GoldenRecordFromJSON,
    GoldenRecordFromJSONTyped,
    GoldenRecordToJSON,
    GoldenRecordToJSONTyped,
} from './GoldenRecord';

/**
 * 
 * @export
 * @interface SplitResponse
 */
export interface SplitResponse {
    /**
     * 
     * @type {boolean}
     * @memberof SplitResponse
     */
    success?: boolean;
    /**
     * 
     * @type {Array<GoldenRecord>}
     * @memberof SplitResponse
     */
    data?: Array<GoldenRecord>;
    /**
     * 
     * @type {string}
     * @memberof SplitResponse
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitResponse
     */
    errorMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitResponse
     */
    userTimezone?: string;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof SplitResponse
     */
    error?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof SplitResponse
     */
    timezoneMetadata?: TimezoneMetadata;
}

/**
 * Check if a given object implements the SplitResponse interface.
 */
export function instanceOfSplitResponse(value: object): value is SplitResponse {
    return true;
}

export function SplitResponseFromJSON(json: any): SplitResponse {
    return SplitResponseFromJSONTyped(json, false);
}

export function SplitResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SplitResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(GoldenRecordFromJSON)),
        'message': json['message'] == null ? undefined : json['message'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'error': json['error'] == null ? undefined : json['error'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
    };
}

export function SplitResponseToJSON(json: any): SplitResponse {
    return SplitResponseToJSONTyped(json, false);
}

export function SplitResponseToJSONTyped(value?: SplitResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(GoldenRecordToJSON)),
        'message': value['message'],
        'errorMessage': value['errorMessage'],
        'userTimezone': value['userTimezone'],
        'error': value['error'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
    };
}

